/* unplugin-vue-components disabled */import { render } from "./sample-item.vue?vue&type=template&id=fa46c676&scoped=true"
import script from "./sample-item.vue?vue&type=script&lang=js"
export * from "./sample-item.vue?vue&type=script&lang=js"

import "./sample-item.vue?vue&type=style&index=0&id=fa46c676&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa46c676"],['__file',"src/components/uploader/sample-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa46c676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa46c676', __exports__)) {
    api.reload('fa46c676', __exports__)
  }
  
  module.hot.accept("./sample-item.vue?vue&type=template&id=fa46c676&scoped=true", () => {
    api.rerender('fa46c676', render)
  })

}


export default __exports__